module.exports = __webpack_public_path__ + "static/media/cennik_pl.277368cd.pdf";